var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Product-whitelist" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
        on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.add } },
                  [_vm._v("新增")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.del()
                      },
                    },
                  },
                  [_vm._v("移除")]
                ),
                _c("el-button", { attrs: { type: "text" } }, [
                  _vm._v("移除的商品将恢复下架条件控制"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", align: "center", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sku_code", align: "center", label: "商品编码" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "商品名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", { attrs: { type: "text" } }, [
                          _vm._v(_vm._s(scope.row.title)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "grade", align: "center", label: "等级" },
              }),
              _c("el-table-column", {
                attrs: { prop: "spec", align: "center", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", align: "center", label: "开市价" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "title-item",
                            on: {
                              click: function ($event) {
                                return _vm.sortChange(1)
                              },
                            },
                          },
                          [
                            _c("div", [_vm._v("开市价")]),
                            _c("div", { staticClass: "title-item-icon" }, [
                              _c("i", {
                                class:
                                  _vm.formData.sort_key == "price" &&
                                  _vm.formData.sort == "asc"
                                    ? "el-icon-caret-top active"
                                    : "el-icon-caret-top ",
                              }),
                              _c("i", {
                                class:
                                  _vm.formData.sort_key == "price" &&
                                  _vm.formData.sort == "desc"
                                    ? "el-icon-caret-bottom active"
                                    : "el-icon-caret-bottom",
                              }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "weight_price",
                  align: "center",
                  label: "净单价",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "quality_percent",
                  align: "center",
                  label: "7天售后率",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "apply_percent",
                  align: "center",
                  label: "3天发起率",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "source_txt", align: "center", label: "来源" },
              }),
              _c("el-table-column", {
                attrs: { prop: "origin_name", align: "center", label: "产地" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  align: "center",
                  label: "添加时间",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }